module.exports = __webpack_public_path__ + "static/media/logo-w.2eb9a1c9.png";